import {ResponsiveImageType} from 'react-datocms';
import {Box, Flex} from '@chakra-ui/layout';
import {useMediaQuery} from '@chakra-ui/react';
import React from 'react';
import {BackButton} from '../global/back-button';
import {DatoCmsImage} from '../datocms/image';

interface OwnAPieceHeroProps {
  image?: ResponsiveImageType;
  bgColor: string;
  marketplace?: boolean;
  setImageHeroBackground: boolean;
  children: React.ReactNode;
}

export const OwnAPieceHero: React.FC<OwnAPieceHeroProps> = ({
  image,
  bgColor,
  marketplace,
  setImageHeroBackground,
  children,
}) => {
  const [isLargerThan1280] = useMediaQuery('(max-width: 50em)');

  return (
    <Box
      bg={bgColor}
      minHeight={{md: '450px', lg: '500px'}}
      position="relative"
      backgroundPosition="top"
      backgroundSize="cover"
      backgroundImage={
        setImageHeroBackground
          ? {
              md: `linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 62.5%), url(${image?.src})`,
              base: 'none',
            }
          : undefined
      }
    >
      <Box
        position="absolute"
        left="76px"
        top="30px"
        display={{base: 'none', md: 'block'}}
      >
        <BackButton />
      </Box>

      <Flex
        minWidth="100%"
        height="100%"
        sx={{alignItems: marketplace && !isLargerThan1280 ? 'top' : 'center'}}
        justify="center"
        flexDirection={{base: 'column', md: 'row'}}
        pt={{base: setImageHeroBackground ? '118px' : '162px', lg: '80px'}}
      >
        {/*  product image */}
        <Box
          minWidth={{
            base: setImageHeroBackground ? '100%' : '185px',
            md: '256px',
            lg: '320px',
          }}
          paddingRight={{base: '0', md: '56px', lg: '100px'}}
          maxW={{
            base: setImageHeroBackground ? '100%' : '185px',
            md: '256px',
            lg: '320px',
          }}
          backgroundPosition="top"
          backgroundSize="cover"
          backgroundImage={{
            base: `linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 62.5%), url(${image?.src})`,
            md: 'none',
          }}
        >
          {setImageHeroBackground ? (
            <Box
              height="350px"
              maxW="100%"
              pt={{base: '0%', md: '100%'}}
              display={{base: 'block', md: 'none'}}
            />
          ) : (
            <DatoCmsImage responsiveImage={image} />
          )}
        </Box>
        {/*  widget */}
        <Box
          width={{base: '100%', md: '400px'}}
          background={{base: 'white', md: 'none'}}
          marginTop={{
            base: setImageHeroBackground ? '0px' : '36px',
            md: setImageHeroBackground ? '36px' : '0',
          }}
          paddingY={{base: 2, md: '0'}}
        >
          <Box maxW={{base: '100%', sm: '400px'}} margin="0 auto">
            {children}
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};
